import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
} from "@mui/material";

const Withdraw = ({ user, token }) => {
  const [depositData, setDepositData] = useState({
    amount: 0, // Initialize amount as a decimal (0.0)
  });

  const [message, setMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Convert the value to a float for the 'amount' field
    const floatValue = parseFloat(value);

    setDepositData({
      ...depositData,
      [name]: floatValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Define the API endpoint for deposit
    const apiUrl = "http://127.0.0.1:3000/deposits";

    // Prepare the request headers
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
    };

    // Prepare the request body
    const requestBody = JSON.stringify(depositData);

    // Make the POST request to the /deposits endpoint
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: requestBody,
      });

      if (!response.ok) {
        // Handle error responses here
        const errorData = await response.json();
        throw new Error(errorData.message || "Network response was not ok");
      }

      // Request was successful
      const data = await response.json();
      setMessage("Deposit successful!");
      console.log("Deposit Data:", data);
    } catch (error) {
      // Handle any errors that occurred during the fetch
      console.error("Error:", error);
      setMessage("An error occurred while processing your request.");
    }
  };

  return (

      <div style={{ flex: "1", padding: "2rem" }}>
        <Typography variant="h4" align="left" gutterBottom>
          Make a Withdrawal
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount"
                name="amount"
                type="number"
                variant="outlined"
                value={depositData.amount}
                onChange={handleInputChange}
                required
              />
            </Grid>
          </Grid>
          <Box mt={3}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
            >
              Withdraw
            </Button>
          </Box>
        </form>
        {message && <p>{message}</p>}
      </div>
  );
};

export default Withdraw;